module.exports = __webpack_public_path__ + "static/media/cal2.9bd52cc8.PNG";